import { useUser } from "hooks/user";
import { useGooglePlayBillingAvailability } from "hooks/subscriptions/play_billing";
import PricingPlans from "./PricingPlans";
import FAQ from "./FAQ";

export default function SubscriptionTemplate({
  onlyPricingTable = false
}: {
  onlyPricingTable?: boolean;
}): JSX.Element {
  const { user } = useUser();
  const { isAvailable: isPlayBillingAvailable } =
    useGooglePlayBillingAvailability();

  return (
    <div className="max-w-full md:mt-12">
      <div className="mb-8 text-center md:mb-16">
        <h1 className="mb-4 text-emphasis-high text-4xl font-bold md:text-5xl">
          Escolha o plano ideal para você
        </h1>
        <p className="mx-auto max-w-3xl text-emphasis-low text-xl">
          Invista no seu futuro acadêmico com o plano que melhor atende às suas
          necessidades de preparação para o ENEM e vestibulares.
        </p>
      </div>

      <PricingPlans
        isPlayBillingAvailable={isPlayBillingAvailable}
        user={user}
      />

      {!onlyPricingTable && <FAQ />}
    </div>
  );
}
